








































































































import { Component, Vue } from 'vue-property-decorator';
import { ServiceRequestModel } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { ObjectFactory } from '../../config/objectFactory';
import { HealthcareProvider, Language } from '../../types/entity';
import { required, email, minLength } from 'vuelidate/lib/validators';
import { ModelSelect } from 'vue-search-select';
import { CommonUtils } from '@/util/commonUtils';
// tslint:disable-next-line: no-var-requires
const validationErrorMessages = require('../../config/validationErrorMessages.json');

@Component({
    props: {
        serviceRequest: Object,
    },
    components: {
        ModelSelect,
    },
    data() {
        return {
            providersOptions: [],
            validationErrorMessages: [],
            showRequiredFieldMessage: false,
            formValidation: {
                isLanguageValid: false,
                isInterpretaionHoursValid: false,
                isFormValid: false,
            },
        };
    },
    validations() {
        const validations: any = {
            serviceRequest: {
                facility: {
                    name: {
                        required,
                    },
                },
                patient: {
                    firstName: {
                        required,
                        regex: (firstName: any) => /^[ a-zA-Z ]+$/.test(firstName),
                    },
                    lastName: {
                        required,
                        regex: (lastName: any) => /^[ a-zA-Z ]+$/.test(lastName),
                    },
                    email: {
                        required,
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(10),
                        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                    },
                },
                telemedicine: {
                    description: {
                        required,
                    },
                    participantEmail: {
                        email,
                    },
                },
        }};
        this.$data.validationErrorMessages = [];
        this.$data.isLanguageMsgAdded = false;
        Object.keys(validations.serviceRequest).forEach((category: any) => {
            Object.keys(validations.serviceRequest[category]).forEach((field: any) => {
                if (validations.serviceRequest[category][field].required &&
                (this.$props.serviceRequest[category][field] === '' || !this.$props.serviceRequest[category][field])) {
                    const path = `${category}.${field}`;
                    const keys = path.split('.');
                    let value = validationErrorMessages;
                    for (const key of keys) {
                        value = value[key];
                    }
                    this.$data.validationErrorMessages.push(value);
                }
            });
            if (validations.serviceRequest[category].required &&
                typeof(this.$props.serviceRequest[category]) === 'undefined') {
                const value = validationErrorMessages[category];
                this.$data.validationErrorMessages.push(value);
            }
        });
        if (this.$props.serviceRequest.telemedicine.interpreterRequired) {
            if (!this.$data.formValidation.isLanguageValid) {
                const keys = ['interpretation', 'language'];
                let value = validationErrorMessages;
                for (const key of keys) {
                    value = value[key];
                }
                if (value) {
                    this.$data.validationErrorMessages.push(value);
                }
            }
            if (!this.$data.formValidation.isInterpretaionHoursValid) {
                const keys = ['interpretation', 'estimatedTime'];
                let value = validationErrorMessages;
                for (const key of keys) {
                    value = value[key];
                }
                if (value) {
                    this.$data.validationErrorMessages.push(value);
                }
            }
        }
        if (this.$props.serviceRequest.telemedicine) {
            if (!this.$data.formValidation.isFormValid
                && (this.$props.serviceRequest.telemedicine.participants.length === 0)) {
                    const keys = ['telemedicine', 'participantEmail'];
                    let value = validationErrorMessages;
                    for (const key of keys) {
                        value = value[key];
                    }
                    if (value) {
                        this.$data.validationErrorMessages.push(value);
                    }
                }
        }
        return validations;
    },
})
export default class MeetingDetails extends Vue {
    private languages: Language[] = [];
    private healthcareProviders: HealthcareProvider[] = [];
    private languageOptions: Array<{ value: any, text: any }> = [];
    private userFullName = '';
    private interpretationServiceTypes = {
        'Phone': 1,
        'In-Person': 2,
        'Video': 1,
    };
    private memberProfile = ObjectFactory.getCacheService().getMemberInfo();

    private mounted() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.patient.preferredLanguage) {
            serviceRequest.patient.preferredLanguage = 'English';
        }
        if (!serviceRequest.stops.isStop1Valid) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
            return;
        }
        const sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
        this.userFullName = sessionInfo.fullname;
        if (serviceRequest.service.selectedType !== 'Telemedicine') {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
            return;
        }
        if (serviceRequest.telemedicine && serviceRequest.telemedicine.interpreterRequired
            && serviceRequest.interpretation) {
            this.languages = serviceRequest.languages as any;
            this.getLanguages(this.interpretationServiceTypes.Video);
            serviceRequest.interpretation.serviceType = 'Video';
        }
        this.validateForm();
        this.getHealthcareProviders();
    }

    private addEmail() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (this.healthcareProviders) {
            this.healthcareProviders.forEach((element) => {
                if (serviceRequest.telemedicine && element.email) {
                    const objIndex = serviceRequest.telemedicine.participants.indexOf(element.email) as number;
                    if (objIndex >= 0) {
                        this.removeParticipant(objIndex);
                    }
                }
            });
            if (serviceRequest.telemedicine) {
                const objIndex = this.healthcareProviders.findIndex(((obj) =>
                    obj.fullname === this.$props.serviceRequest.facility.name));
                const providerEmail = this.healthcareProviders[objIndex].email;
                if (providerEmail) {
                    const found = serviceRequest.telemedicine.participants.indexOf
                        (providerEmail) as number;
                    if (found! < 0) {
                        serviceRequest.telemedicine.participants.push(providerEmail);
                    }
                }
            }
        }
        this.validateForm();
    }

    private nextStep() {
        if (this.$v.$invalid || !this.$data.formValidation.isFormValid) {
            this.$data.showRequiredFieldMessage = true;
        } else {
            this.$props.serviceRequest.stops.isStop2Valid = true;
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING });
        }
    }

    private preStep() {
        this.$router.go(-1);
    }

    private async getLanguages(serviceType: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.languages || serviceRequest.languages.length <= 0) {
            const response = await ObjectFactory.getRequestService().
                getLanguages(serviceType, this.$store.state.serverUrl);
            serviceRequest.languages = response.data;
            this.validateForm();
        }
        this.languages = serviceRequest.languages as any;
        if (this.languageOptions.length < 1) {
            this.languages.forEach((language) => {
                const option = {
                    value: language.name,
                    text: language.name,
                };
                this.languageOptions.push(option);
            });
        }
    }

    private validateForm() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.interpretation && serviceRequest.telemedicine
            && serviceRequest.telemedicine.interpreterRequired) {
            this.$data.formValidation.isFormValid = false;
            if (!serviceRequest.interpretation.language) {
                this.$data.formValidation.isLanguageValid = false;
            } else {
                this.$data.formValidation.isLanguageValid = true;
            }

            if ((!serviceRequest.interpretation.estimatedTime.hours
                || serviceRequest.interpretation.estimatedTime.hours <= 0)) {
                this.$data.formValidation.isInterpretaionHoursValid = false;
            } else {
                this.$data.formValidation.isInterpretaionHoursValid = true;
            }
            this.$data.formValidation.isFormValid = this.$data.formValidation.isInterpretaionHoursValid
                && this.$data.formValidation.isLanguageValid;
        } else {
            this.$data.formValidation.isFormValid = true;
        }

        if (serviceRequest.telemedicine) {
            this.$data.formValidation.isFormValid = this.$data.formValidation.isFormValid
                && (serviceRequest.telemedicine.participants.length > 0);
        }
    }

    private addParticipant() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.telemedicine && this.$v.serviceRequest
            && this.$v.serviceRequest.telemedicine && this.$v.serviceRequest.telemedicine.participantEmail.email) {
            if (!serviceRequest.telemedicine.participants.includes(serviceRequest.telemedicine.participantEmail)) {
                serviceRequest.telemedicine.participants.push(serviceRequest.telemedicine.participantEmail);
            }
            serviceRequest.telemedicine.participantEmail = '';
            this.validateForm();
        }
    }

    private removeParticipant(index: any) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.telemedicine) {
            serviceRequest.telemedicine.participants.splice(index, 1);
        }
        this.validateForm();
    }

    private async getHealthcareProviders() {
        const response = await ObjectFactory.getProviderService()
            .getHealthcareProviders(this.$store.state.serverUrl, '', 0);
        this.healthcareProviders = response.data as any;
        this.healthcareProviders.forEach((healthcareProvider) => {
            const providersOption = {
                value: healthcareProvider.fullname,
                text: healthcareProvider.fullname,
            };
            this.$data.providersOptions.push(providersOption);
        });
    }

    private maskPhone(phone: string) {
         return CommonUtils.phoneNumberMask(phone);
    }

}
